"use client";

import { motion } from "framer-motion";
import Image from "next/image";
import { useState } from "react";

import { MuxPlayer } from "@/components/post-rich-text/mux-player";
import { Dialog, DialogClose, DialogTitle } from "@/components/ui/dialog";
import {
  VideoDialogPopup,
  videoDialogCloseIconClass,
} from "@/components/ui/video-dialog";

const preloadMuxPlayer = () => {
  import("@mux/mux-player-react/lazy");
};

type Props = {
  image: { src: string; width: number; height: number; alt: string };
  playbackId: string;
};

export function BfStaticVideoThumbnail({ image, playbackId }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <figure className="relative col-span-full">
        <motion.button
          onClick={() => setOpen(true)}
          onMouseEnter={preloadMuxPlayer}
          onTouchStart={preloadMuxPlayer}
          whileHover="hover"
          className="relative z-10 block w-full"
          aria-label="Play video"
        >
          <Image
            src={image.src}
            alt={image.alt}
            width={image.width}
            height={image.height}
            priority
            fetchPriority="high"
            quality={90}
            sizes="(min-width: 624px) 83vw, 100vw"
            className="block h-auto w-full"
          />
          <motion.span
            className="bg-pulse-700 absolute top-1/2 left-1/2 z-20 flex size-[67px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full lg:size-[88px]"
            variants={{ hover: { scale: 1.1 } }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path d="M4 13L13 8L4 3V13Z" fill="white" />
            </svg>
          </motion.span>
        </motion.button>
      </figure>

      <Dialog open={open} onOpenChange={setOpen}>
        <VideoDialogPopup initialFocus={false}>
          <DialogTitle className="sr-only">Video</DialogTitle>
          <div className="rounded-container relative aspect-video overflow-hidden">
            <MuxPlayer
              playbackId={playbackId}
              autoPlay="any"
              loading="page"
              preload="auto"
              renditionOrder="desc"
              minResolution="1080p"
              className="absolute inset-0"
            />
          </div>
          <DialogClose className={videoDialogCloseIconClass} />
        </VideoDialogPopup>
      </Dialog>
    </>
  );
}
